export const setZoomLevel = (zoomLevel) => ({
    type: 'SET_ZOOM_LEVEL',
    payload: zoomLevel,
});